((LaunchParallax, $) => {
  'use strict';

  const scrollSpeedDivider = 4;
  const mobileBreak = 992;

  let $window;
  let $hero;
  let $image;

  const showImage = () => {
    $image.css('opacity', 1);
  };

  const parallax = ($this) => {
    const scrollHeight = $this.scrollTop();
    $image.css('transform', `translateY(-${(scrollHeight / scrollSpeedDivider)}px)`);
  };

  const initialize = () => {
    if (checkScroll($window)) {
      parallax($window);
    } else {
      reset();
    }
    showImage();
  };

  const checkScroll = ($this) => {
    return $this.scrollTop() < $hero.height() && $this.width() > mobileBreak;
  };

  const reset = () => {
    $image.css('transform', 'translateY(0)');
  };

  const cacheDom = () => {
    $window = $(window);
    $hero = $('.js-launch-hero');
    $image = $hero.find('.js-launch-hero-image');
  };

  const bindUIActions = () => {
    $window.on('scroll', function () {
      if (checkScroll($(this))) {
        parallax($(this));
      }
    });

    $window.on('resize', function () {
      initialize();
    });
  };

  const init = () => {
    cacheDom();
    initialize();
    bindUIActions();
  };

  LaunchParallax.init = init;

})(window.LaunchParallax = window.LaunchParallax || {}, jQuery);
